<template>
  <div class="section-content">
    <h2 class="text-title">{{ event.title }}</h2>
    <div class="event-picture" v-if="event.img"><img :src="event.img" alt=""></div>
    <div class="text-body" v-html="event.body"></div>
    <div class="sound-player">
      <audio ref="audio"  :autoplay="audioDeactivated ? false : selected">
        <source :src="event.mp3" type="audio/mp4">
          Your browser does not support the audio element.
      </audio>
      <img @click="pause" v-if="playing" src="@/assets/images/Pause.svg"/>
      <img @click="play" v-if="!playing" src="@/assets/images/Play.svg"/>
      <div class="progress" ref="progress" @click="move">
        <progress-bar  size="4" :val="playPercentage" bar-color="#9a6969" bg-color="#18333c13"/>
      </div>
    </div>
    <div v-if="event.isLast">
      <p class="explore-text"> {{ $t('message.Visit_the_traditiona') }} </p>
      <div class="landing-links explore-link">
        <div class="landing-link">

          <div class="link-item" @click="$router.push('/explore-the-land')">
            {{ $t('message.Explore_the_Land') }} >
          </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>

import ProgressBar from 'vue-simple-progress'
export default {
  name: 'Event',
  props: ['event', 'selected', 'opacity'],
  components: {
    ProgressBar
  },
  data () {
    return {
      currentTime: 0,
      duration: 1,
      playing: false,
      previousPlayingState: this.$store.state.audioDeactivated
    }
  },
  computed: {
    audioDeactivated () {
      return this.$store.state.audioDeactivated
    },
    playPercentage () {
      return Math.floor((100 / this.duration) * this.currentTime)
    },
    modalOpened () {
      return this.$store.state.modal.opened
    }
  },
  methods: {
    play () {
      this.$refs.audio.play()
      this.playing = true
    },
    pause () {
      this.wasPaused = this.$refs.audio.paused
      this.$refs.audio.pause()
      this.playing = false
    },
    move (e) {
      const percentage = e.offsetX / this.$refs.progress.offsetWidth
      this.$refs.audio.currentTime = Math.floor(this.duration * percentage)
    }
  },
  watch: {
    opacity (newValue) {
      this.$refs.audio.volume = newValue
    },
    selected (newValue) {
      if (newValue) {
        this.$refs.audio.ontimeupdate = () => {
          if (this.$refs.audio) {
            this.currentTime = this.$refs.audio.currentTime
            this.duration = this.$refs.audio.duration
          }
        }
        if (!this.audioDeactivated) {
          this.play()
          this.$refs.audio.onended = () => {
            this.$store.dispatch('next')
          }
        }
      } else {
        this.$refs.audio.currentTime = 0
        this.pause()
      }
    },
    modalOpened (newValue) {
      if (newValue) {
        this.pause()
      } else {
        if (!this.wasPaused && !this.audioDeactivated) this.play()
      }
    }
  }
}
</script>

<style lang="scss">
.event-picture {
  margin-bottom: 16px;
  img {
    width: 100%;
  }
}

.section-content {
  max-width: 360px;
  @media only screen and (max-width: 768px) {
    max-width: 240px;
  }
  @media only screen and (max-width: 400px) {
    max-width: 180px;
  }
  .text-title {
    font-family: 'CAPUTTRIAL';
    font-weight: normal;
    font-size: 32px;
    @media only screen and (max-width: 768px) {
      font-size: 16px;
  }
    text-transform: uppercase;
    font-family: CAPUTTRIAL;
    line-height: 1.25;
    color: #244a56;

    // padding-bottom: 24px;
  }
  .text-body {
    font-family: Georgia, 'Times New Roman', Times, serif;
    font-size: 16px;
    color: #18333c;
    line-height: 1.5
  }
  .sound-player {
    display: flex;
    flex-direction: row;
    img {
      align-self: center;
    }
    .progress {
      width: 328px;
      align-self: center;
      margin-left: 8px;
      cursor: pointer;
    }
  }
}
.explore-link {
  margin-top: 24px

}
.explore-link:hover {
  .link-item {
    color: white;
    background-color: #9a6969
  }
}
.explore-text {
  margin-top: 48px;
  font-family: Georgia, 'Times New Roman', Times, serif;
  font-size: 16px;
  color: #18333c;
  line-height: 1.5
}
</style>
